export default "__VITE_ASSET__BKYcjvSE__"